function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.54,277.61S474.65,156.7,403.41,100c-62.89-50.08-151-59.2-212,.58-21.71,21.29-34.09,57.81-61,72.85-30.23,16.87-70.86,27.75-92.57,82.52S37.21,373,82.53,400.64,192,383.69,254.35,371,462.19,427.73,471.54,277.61Z",
    style: {
      fill: "#444444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.54,277.61S474.65,156.7,403.41,100c-62.89-50.08-151-59.2-212,.58-21.71,21.29-34.09,57.81-61,72.85-30.23,16.87-70.86,27.75-92.57,82.52S37.21,373,82.53,400.64,192,383.69,254.35,371,462.19,427.73,471.54,277.61Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.43,68.92s0-26.39-30.41-27c-25.88-.48-27,20.09-29.83,29.84s-7.46,0-18.36,2.29-10.9,13.2-12.63,20.09S284,93,276,95.31s-12.05,10.9-13.77,14.35-13.56-1.77-20.53.77S227.22,124,227.22,124H430.9s8-18.93-5.73-31.56-22.95-4.59-31.56-8.6S384.43,68.92,384.43,68.92Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,169.32s0-16.12-18.56-16.47c-15.8-.29-16.46,12.26-18.22,18.22s-4.55,0-11.21,1.4-6.65,8.06-7.7,12.26-5.61-.7-10.51.7-7.36,6.66-8.41,8.76-8.28-1.08-12.53.47S12.22,203,12.22,203H136.58s4.9-11.56-3.5-19.27-14-2.8-19.27-5.25S108.2,169.32,108.2,169.32Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.36,
    y: 298.09,
    width: 10,
    height: 8.83,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.54,
    y: 303.44,
    width: 4.06,
    height: 3.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "484.51 353.84 446.6 353.84 446.6 283.78 449.13 283.78 449.13 276.53 360.29 276.53 360.29 283.78 363.37 283.78 363.37 387.97 340.07 387.97 340.07 164.44 260.17 164.44 260.17 333.49 230.95 333.49 230.95 314.77 238.6 314.77 238.6 306.86 174.72 306.86 174.72 193.46 178.85 193.46 178.85 187.52 101.31 187.52 101.31 193.46 106.87 193.46 106.87 307.05 45.58 307.05 45.58 388.3 13.4 388.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.61,
    y: 162,
    width: 86.64,
    height: 2.43,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 200.05,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 200.05,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 200.05,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 200.05,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 214.55,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 214.55,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 214.55,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 214.55,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 229.06,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 229.06,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 229.06,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 229.06,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 243.56,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 243.56,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 243.56,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 243.56,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 258.07,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 258.07,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 258.07,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 258.07,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 272.58,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 272.58,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 272.58,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 272.58,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 287.08,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 287.08,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 287.08,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 287.08,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 301.59,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 301.59,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 301.59,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 301.59,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.43,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.75,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.71,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.03,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.65,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.71,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.03,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.65,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.71,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.03,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.65,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.71,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.03,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.65,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.71,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.03,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.65,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.71,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.03,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.65,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.71,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.03,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.65,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.71,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.03,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.65,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.11,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.43,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.05,
    y: 314.85,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.11,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.43,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.05,
    y: 329.36,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.11,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.43,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.05,
    y: 343.86,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.11,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.43,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.05,
    y: 358.37,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.11,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.43,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.05,
    y: 372.88,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.11,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.43,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.05,
    y: 387.38,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.11,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.43,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.05,
    y: 401.89,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.11,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.43,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.05,
    y: 416.39,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.86,
    y: 286.42,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.17,
    y: 286.42,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 286.42,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.8,
    y: 286.42,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.86,
    y: 300.93,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.17,
    y: 300.93,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 300.93,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.8,
    y: 300.93,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.86,
    y: 315.43,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.17,
    y: 315.43,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 315.43,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.8,
    y: 315.43,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.86,
    y: 329.94,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.17,
    y: 329.94,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 329.94,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.8,
    y: 329.94,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.86,
    y: 344.44,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.17,
    y: 344.44,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 344.44,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.8,
    y: 344.44,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.86,
    y: 358.95,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.17,
    y: 358.95,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 358.95,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.8,
    y: 358.95,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.86,
    y: 373.45,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.17,
    y: 373.45,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 373.45,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.8,
    y: 373.45,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.86,
    y: 387.96,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.17,
    y: 387.96,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.48,
    y: 387.96,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.8,
    y: 387.96,
    width: 9.76,
    height: 9.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.69,
    y1: 169.72,
    x2: 267.69,
    y2: 434.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.37,
    y1: 169.72,
    x2: 277.37,
    y2: 434.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.05,
    y1: 169.72,
    x2: 287.05,
    y2: 434.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.73,
    y1: 169.72,
    x2: 296.73,
    y2: 434.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.41,
    y1: 169.72,
    x2: 306.41,
    y2: 434.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.09,
    y1: 169.72,
    x2: 316.09,
    y2: 434.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.77,
    y1: 169.72,
    x2: 325.77,
    y2: 434.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.45,
    y1: 169.72,
    x2: 335.45,
    y2: 434.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.18,385.1a24.81,24.81,0,0,0,8.83,0c0,1.79,0,3.68.21,5.64a48.8,48.8,0,0,0,1.43,8.48l0,.1c-.49-.78-1.94-2.9-2.07-3.05-1.83-2.11-6.62-5.13-9.5-3.9a3.7,3.7,0,0,0-1.64,5.27c1.06,1.93,3.61,2.89,5.68,3.19,2.33.34,7.24-1.08,7.63-1.19a65.73,65.73,0,0,0,3,8.23c.67,1.57,1.4,3.12,2.15,4.67-.45-.66-.85-1.24-.92-1.32-1.83-2.11-6.61-5.12-9.49-3.9a3.71,3.71,0,0,0-1.65,5.27c1.07,1.94,3.62,2.9,5.69,3.2s6.31-.83,7.42-1.14l.87,1.77c1.43,2.83,2.86,5.65,4.17,8.46.47,1,.89,2,1.32,3-.4-.58-.74-1.07-.8-1.14-1.83-2.12-6.61-5.13-9.5-3.9a3.7,3.7,0,0,0-1.64,5.26c1.07,1.94,3.62,2.9,5.68,3.2s5.9-.71,7.22-1.08c.41,1,.81,2.06,1.16,3.07.22.7.48,1.35.66,2.07s.39,1.39.59,2.08c.32,1.34.66,2.72.94,4,.2.91.38,1.79.56,2.67-.46-1-1.38-2.91-1.48-3.06-1.49-2.37-5.75-6.07-8.79-5.3a3.7,3.7,0,0,0-2.42,5c.76,2.07,3.13,3.41,5.13,4,2.2.67,7.07.06,7.68,0,.29,1.45.56,2.87.8,4.21.18,1,.34,2,.49,3h1.95c-.19-1.05-.39-2.15-.62-3.29-.29-1.48-.63-3.05-1-4.67a39.14,39.14,0,0,0,4.28-2c1.6,1.74,5.71,3.77,6.25,4-.56,1.37-1.12,2.7-1.67,3.95-.29.69-.58,1.34-.87,2H59c.17-.42.35-.83.52-1.26.58-1.4,1.16-2.9,1.75-4.45.59.13,5.41,1.11,7.66.6,2-.46,4.51-1.61,5.42-3.63a3.71,3.71,0,0,0-2-5.12c-3-1-7.5,2.37-9.16,4.62-.1.13-1,1.69-1.56,2.69.24-.64.48-1.25.71-1.9.48-1.29.91-2.6,1.38-4,.21-.68.42-1.37.62-2.07s.37-1.45.56-2.17c.41-1.7.73-3.44,1-5.2,1.14.42,5.18,1.82,7.27,1.68s4.7-.92,5.91-2.77a3.71,3.71,0,0,0-1.25-5.38C75,422.06,70,424.71,68,426.68c-.12.12-1.38,1.7-2.06,2.58.16-1.06.34-2.12.47-3.19.38-3.11.68-6.27,1-9.41l.3-2.89c.41.15,5.17,1.93,7.52,1.76,2.08-.14,4.7-.91,5.91-2.76a3.71,3.71,0,0,0-1.25-5.38c-2.78-1.43-7.78,1.21-9.76,3.19-.15.15-2,2.42-2.4,3,.23-2.12.47-4.23.79-6.3A65.49,65.49,0,0,1,70.34,399c.18.07,5.15,2,7.56,1.78,2.08-.15,4.7-.92,5.9-2.77a3.71,3.71,0,0,0-1.24-5.37c-2.79-1.44-7.78,1.21-9.76,3.18-.13.13-1.52,1.86-2.16,2.7l-.16-.09a47.17,47.17,0,0,1,3.29-7.85c.71-1.4,1.47-2.69,2.24-3.93.89.44,5,2.43,7.16,2.51s4.77-.39,6.17-2.1a3.71,3.71,0,0,0-.65-5.48c-2.61-1.73-7.86.35-10,2.1-.08.06-.63.61-1.22,1.2,0-.13,0-.28,0-.45s.17-.28.26-.41c1.31-2,2.63-3.7,3.81-5.22.68-.86,1.31-1.62,1.91-2.33,1.1,0,5.54-.15,7.48-1.06s4-2.55,4.51-4.71a3.71,3.71,0,0,0-3.1-4.57c-3.12-.33-6.82,3.94-8,6.49-.1.22-1.24,3.86-1.18,3.86h.07c-.59.67-1.22,1.4-1.88,2.2-1.22,1.49-2.57,3.19-3.92,5.12,0-3-.56-9.27-4.54-9.65-5.25-.5-6.75,5.5-3.5,8.75a9.63,9.63,0,0,0,6.89,2.58c-1,1.5-2,3.11-3,4.87a48.92,48.92,0,0,0-3.49,7.85l0,.1c0-.92,0-3.48,0-3.68-.36-2.78-2.68-7.93-5.77-8.5a3.7,3.7,0,0,0-4.27,3.49c-.18,2.21,1.42,4.41,3,5.81,1.76,1.57,6.64,3.09,7,3.21a65.27,65.27,0,0,0-2.06,8.51c-.3,1.67-.55,3.37-.78,5.08,0-.8,0-1.51,0-1.61-.36-2.77-2.68-7.92-5.77-8.49a3.7,3.7,0,0,0-4.27,3.49c-.18,2.2,1.42,4.41,3,5.8s5.72,2.79,6.82,3.14c-.08.66-.17,1.31-.25,2-.37,3.14-.74,6.28-1.18,9.35-.16,1.08-.36,2.14-.55,3.2,0-.7,0-1.3,0-1.39-.36-2.77-2.68-7.92-5.76-8.49a3.71,3.71,0,0,0-4.28,3.49c-.18,2.2,1.42,4.41,3,5.8s5.31,2.65,6.61,3.08c-.23,1.08-.45,2.16-.72,3.2-.2.7-.35,1.39-.59,2.09l-.66,2.06c-.47,1.29-1,2.63-1.44,3.88-.34.87-.67,1.7-1,2.53.17-1.08.46-3.19.46-3.37a14.22,14.22,0,0,0-1.93-7,3.86,3.86,0,0,0-4.58-4c-3,.81-5,6.12-5.09,8.92,0,.16.1,2,.18,3.1-.15-.66-.29-1.3-.46-2-.31-1.34-.67-2.67-1.05-4.1-.2-.68-.41-1.37-.62-2.07s-.49-1.4-.74-2.12c-.59-1.63-1.28-3.26-2-4.89,1.17-.28,5.32-1.34,7-2.62s3.41-3.35,3.4-5.56a3.71,3.71,0,0,0-4-3.8c-3.11.34-5.82,5.3-6.38,8,0,.17-.22,2.19-.3,3.29-.45-1-.89-1.95-1.37-2.92-1.39-2.8-2.89-5.6-4.37-8.39-.45-.86-.89-1.72-1.34-2.57.42-.1,5.38-1.25,7.24-2.68,1.66-1.27,3.42-3.35,3.4-5.57a3.7,3.7,0,0,0-4-3.79c-3.12.34-5.82,5.3-6.39,8,0,.21-.3,3.1-.33,3.84-1-1.89-1.94-3.78-2.81-5.68a64.2,64.2,0,0,1-3.06-7.9c.19,0,5.37-1.22,7.28-2.69,1.66-1.27,3.42-3.35,3.4-5.56a3.71,3.71,0,0,0-4-3.8c-3.12.34-5.82,5.3-6.39,8,0,.18-.23,2.39-.31,3.44l-.17,0a48.09,48.09,0,0,1-1.6-8.37c-.17-1.56-.25-3.05-.3-4.51,1-.12,5.49-.72,7.36-1.85s3.76-3,4-5.16a3.7,3.7,0,0,0-3.56-4.21c-3.14,0-6.37,4.63-7.23,7.29,0,.14-.36,1.67-.57,2.78,0-.66,0-1.34,0-2,0-2.37.15-4.54.3-6.46.09-1.09.2-2.07.31-3,.9-.63,4.53-3.18,5.64-5s2-4.36,1.17-6.42a3.72,3.72,0,0,0-5.11-2.1c-2.78,1.44-3.51,7-3.05,9.8,0,.24,1.09,3.9,1.14,3.87l.05,0c-.12.89-.24,1.83-.35,2.87-.19,1.92-.39,4.1-.45,6.48,0,.43,0,.88,0,1.33-1.2-1.84-5-7-9-5.9C14.05,379.79,15.19,384.16,19.18,385.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.84,409.24a16.09,16.09,0,0,0,5.64,0,34.34,34.34,0,0,0,.14,3.6,30.54,30.54,0,0,0,.9,5.41.25.25,0,0,1,0,.07c-.31-.5-1.24-1.85-1.32-1.95-1.17-1.35-4.22-3.27-6.06-2.49a2.37,2.37,0,0,0-1,3.37,5,5,0,0,0,3.63,2,16.43,16.43,0,0,0,4.87-.77,40,40,0,0,0,1.9,5.26c.43,1,.9,2,1.38,3l-.59-.84c-1.17-1.35-4.22-3.27-6.06-2.49a2.36,2.36,0,0,0-1,3.36,4.93,4.93,0,0,0,3.63,2,15.54,15.54,0,0,0,4.73-.72c.19.37.37.75.56,1.13.91,1.81,1.82,3.6,2.66,5.4.3.63.57,1.26.84,1.89-.25-.37-.47-.68-.51-.72-1.17-1.35-4.22-3.28-6.06-2.5A2.38,2.38,0,0,0,97,436.66a5,5,0,0,0,3.63,2,15.11,15.11,0,0,0,4.61-.69c.26.65.52,1.31.74,2,.14.44.31.86.42,1.32s.25.89.37,1.33c.21.85.43,1.73.6,2.57.13.58.25,1.14.36,1.7-.29-.63-.88-1.85-.94-1.95-1-1.51-3.68-3.88-5.61-3.38a2.36,2.36,0,0,0-1.55,3.16,4.92,4.92,0,0,0,3.28,2.57,16.3,16.3,0,0,0,4.9,0c.19.92.36,1.83.51,2.69.11.65.22,1.27.31,1.88h1.25c-.12-.67-.25-1.37-.4-2.1-.18-.94-.4-1.95-.63-3a24.77,24.77,0,0,0,2.73-1.29,17.22,17.22,0,0,0,4,2.57c-.36.88-.71,1.73-1.06,2.53l-.56,1.27h1.32l.33-.81c.37-.89.74-1.85,1.12-2.83a16.66,16.66,0,0,0,4.89.38,5,5,0,0,0,3.46-2.32,2.36,2.36,0,0,0-1.31-3.27c-1.9-.64-4.79,1.51-5.85,2.95-.06.09-.64,1.08-1,1.72.15-.41.3-.8.45-1.22.3-.82.58-1.65.88-2.55.13-.44.26-.88.4-1.32s.23-.92.35-1.39c.26-1.08.47-2.19.65-3.31a15.57,15.57,0,0,0,4.65,1.06,4.94,4.94,0,0,0,3.77-1.76,2.37,2.37,0,0,0-.8-3.43c-1.78-.92-5,.77-6.23,2-.08.08-.89,1.08-1.32,1.65.11-.68.22-1.35.3-2,.25-2,.44-4,.63-6,.06-.62.13-1.23.19-1.84.26.1,3.3,1.23,4.8,1.12a4.94,4.94,0,0,0,3.77-1.76,2.36,2.36,0,0,0-.79-3.43c-1.78-.92-5,.77-6.23,2-.1.09-1.26,1.54-1.54,1.93.15-1.35.3-2.7.51-4a41.84,41.84,0,0,1,1.15-5.28c.12,0,3.29,1.24,4.83,1.13a4.94,4.94,0,0,0,3.77-1.76,2.38,2.38,0,0,0-.8-3.44c-1.78-.91-5,.78-6.23,2-.08.08-1,1.18-1.37,1.72l-.11-.05a30.36,30.36,0,0,1,2.1-5c.46-.89.94-1.72,1.43-2.51a15.9,15.9,0,0,0,4.57,1.61,5,5,0,0,0,3.94-1.34,2.37,2.37,0,0,0-.41-3.5c-1.67-1.11-5,.22-6.42,1.34l-.78.76c0-.08,0-.18,0-.29l.16-.25c.84-1.26,1.68-2.37,2.44-3.34.43-.55.84-1,1.22-1.48a16.13,16.13,0,0,0,4.77-.68,5,5,0,0,0,2.88-3,2.36,2.36,0,0,0-2-2.91c-2-.22-4.35,2.51-5.08,4.14-.06.14-.79,2.46-.75,2.46h0c-.38.42-.78.89-1.2,1.4-.77,1-1.64,2-2.5,3.27,0-1.92-.36-5.92-2.9-6.16-3.35-.32-4.31,3.51-2.23,5.59a6.14,6.14,0,0,0,4.4,1.64c-.65,1-1.29,2-1.9,3.11a31,31,0,0,0-2.22,5s0,.05,0,.07c0-.59,0-2.23,0-2.35-.23-1.78-1.72-5.06-3.68-5.43a2.37,2.37,0,0,0-2.73,2.23,4.9,4.9,0,0,0,1.9,3.7,16,16,0,0,0,4.48,2.05,44.09,44.09,0,0,0-1.32,5.44c-.19,1.07-.35,2.15-.49,3.24,0-.51,0-1,0-1-.23-1.78-1.71-5.06-3.68-5.43a2.37,2.37,0,0,0-2.73,2.23,5,5,0,0,0,1.9,3.7,15.39,15.39,0,0,0,4.35,2c0,.42-.11.84-.16,1.25-.24,2-.47,4-.75,6-.1.69-.23,1.36-.35,2,0-.45,0-.83,0-.89-.22-1.77-1.71-5.06-3.68-5.42a2.38,2.38,0,0,0-2.73,2.23,5,5,0,0,0,1.9,3.7,15.29,15.29,0,0,0,4.23,2c-.15.69-.29,1.38-.47,2-.12.45-.22.89-.37,1.33s-.28.88-.42,1.32c-.3.82-.61,1.68-.92,2.48l-.64,1.61c.1-.68.29-2,.29-2.15a9.17,9.17,0,0,0-1.23-4.47,3,3,0,0,0,0-.52,2.36,2.36,0,0,0-2.89-2c-1.93.51-3.16,3.91-3.25,5.69,0,.11.06,1.25.12,2-.1-.42-.19-.83-.29-1.26-.21-.86-.43-1.7-.68-2.62-.13-.43-.26-.87-.4-1.32s-.31-.9-.46-1.35c-.39-1.05-.82-2.09-1.29-3.13a15.4,15.4,0,0,0,4.46-1.67,4.94,4.94,0,0,0,2.17-3.55,2.36,2.36,0,0,0-2.55-2.42c-2,.21-3.72,3.38-4.08,5.13,0,.11-.14,1.39-.19,2.1-.29-.62-.57-1.24-.87-1.86-.89-1.79-1.85-3.58-2.79-5.36l-.86-1.64c.27-.07,3.43-.8,4.62-1.71a5,5,0,0,0,2.17-3.56,2.36,2.36,0,0,0-2.55-2.42c-2,.22-3.72,3.38-4.08,5.13,0,.14-.19,2-.21,2.46-.63-1.21-1.24-2.42-1.8-3.63a41.79,41.79,0,0,1-2-5c.12,0,3.43-.78,4.65-1.72a4.94,4.94,0,0,0,2.17-3.55,2.37,2.37,0,0,0-2.56-2.43c-2,.22-3.71,3.39-4.07,5.14,0,.11-.15,1.52-.2,2.19H97a30,30,0,0,1-1-5.34c-.11-1-.16-2-.19-2.88a16.06,16.06,0,0,0,4.7-1.18,4.93,4.93,0,0,0,2.54-3.29,2.36,2.36,0,0,0-2.27-2.69c-2,0-4.06,2.95-4.62,4.65,0,.09-.23,1.07-.36,1.78,0-.42,0-.86,0-1.26,0-1.51.1-2.9.19-4.12.06-.7.13-1.33.2-1.91a16,16,0,0,0,3.6-3.2,5,5,0,0,0,.75-4.1,2.37,2.37,0,0,0-3.26-1.34c-1.78.92-2.25,4.5-2,6.26,0,.15.69,2.49.72,2.47l0,0c-.08.57-.16,1.17-.23,1.84-.12,1.22-.25,2.61-.28,4.13,0,.28,0,.56,0,.85-.76-1.17-3.16-4.47-5.76-3.77C86.57,405.85,87.3,408.63,89.84,409.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.86,385.48l-.23.23c.05-.07.09-.15.14-.23Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 72.61,
    width: 175.72,
    height: 341.96,
    rx: 20,
    style: {
      fill: "#444444",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.39,104.1V93.7a21.08,21.08,0,0,0-21.08-21.09H108.76A21.09,21.09,0,0,0,87.67,93.7v10.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6,399.67a21.08,21.08,0,0,0,20.16,14.9H242.31a21.09,21.09,0,0,0,20.16-14.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.4,
    y: 84.66,
    width: 16.67,
    height: 9.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.821067px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.4,
    y: 84.66,
    width: 13,
    height: 9.14,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.725073px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.04,
    y: 87.22,
    width: 2.35,
    height: 4.03,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.725073px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.22,
    y: 87.5,
    width: 3.06,
    height: 5.24,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8830859999999999px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.02,
    y: 85.66,
    width: 3.06,
    height: 7.08,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8830859999999999px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.82,
    y: 83.48,
    width: 3.06,
    height: 9.25,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8830859999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.46,69.8H102.19A17.55,17.55,0,0,0,84.64,87.35V402.51a17.54,17.54,0,0,0,17.55,17.54H246.46A17.54,17.54,0,0,0,264,402.51V87.35A17.54,17.54,0,0,0,246.46,69.8Zm9.74,324.34a17.54,17.54,0,0,1-17.54,17.54H110a17.54,17.54,0,0,1-17.54-17.54V95.72A17.54,17.54,0,0,1,110,78.17h23.94l1.49,6.92a9,9,0,0,0,8.84,7.13H208.3a9,9,0,0,0,8.83-7.13l1.49-6.92h20A17.54,17.54,0,0,1,256.2,95.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.6935px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.81,
    y: 125.19,
    width: 127.93,
    height: 258.67,
    rx: 8.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,140.42c2.1,0,3.18,1.25,3.18,3.45v.43h-2v-.57c0-1-.39-1.35-1.08-1.35s-1.07.37-1.07,1.35c0,2.82,4.21,3.35,4.21,7.27,0,2.19-1.1,3.45-3.21,3.45s-3.22-1.26-3.22-3.45v-.84h2v1c0,1,.43,1.33,1.12,1.33s1.11-.35,1.11-1.33c0-2.82-4.21-3.35-4.21-7.27C153.9,141.67,155,140.42,157.07,140.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.51,140.57h2.15v13.72h-2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,146.65h3V151c0,2.19-1.1,3.45-3.21,3.45s-3.22-1.26-3.22-3.45v-7.13c0-2.2,1.1-3.45,3.22-3.45s3.21,1.25,3.21,3.45v1.33h-2v-1.47c0-1-.43-1.35-1.11-1.35s-1.12.37-1.12,1.35v7.41c0,1,.43,1.33,1.12,1.33s1.11-.35,1.11-1.33v-2.53h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.79,144.36v9.93h-1.94V140.57h2.71l2.21,8.22v-8.22h1.92v13.72h-2.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.28,140.57h2.16v13.72h-2.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93,144.36v9.93H188V140.57h2.7l2.22,8.22v-8.22h1.92v13.72h-2.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,192.81v1h-2.53v3.68h3.1v1h-4.25V188.24h4.25v1h-3.1v3.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.56,198.56h-1.11l-1.72-8.23v8.24h-1V188.24h1.61l1.7,8.25,1.64-8.25h1.61v10.33h-1.1v-8.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,196.49l-.4,2.08h-1.06l2-10.33h1.67l2,10.33h-1.16l-.39-2.08Zm.15-1h2.3l-1.16-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85,188.24v10.33h-1.16V188.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,198.57V188.24h1.15v9.29h2.95v1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.45,196.49l-.39,2.08H146l2-10.33h1.67l2,10.33h-1.15l-.4-2.08Zm.15-1h2.31l-1.17-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.94,188.24c1.61,0,2.35,1,2.35,2.57V196c0,1.58-.74,2.55-2.35,2.55h-2.42V188.24Zm0,9.29c.83,0,1.23-.52,1.23-1.47v-5.31c0-.95-.4-1.47-1.24-1.47h-1.24v8.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,188.24c1.61,0,2.35,1,2.35,2.57V196c0,1.58-.74,2.55-2.35,2.55h-2.42V188.24Zm0,9.29c.83,0,1.23-.52,1.23-1.47v-5.31c0-.95-.4-1.47-1.25-1.47h-1.24v8.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.51,188.24c1.63,0,2.31.82,2.31,2.36v.84c0,1.14-.4,1.85-1.29,2.13.95.28,1.3,1.05,1.3,2.15v1.61a2.48,2.48,0,0,0,.21,1.24h-1.17a2.72,2.72,0,0,1-.19-1.25v-1.63c0-1.16-.55-1.53-1.51-1.53h-.81v4.41h-1.15V188.24Zm-.29,4.87c.91,0,1.46-.3,1.46-1.42v-1c0-.93-.34-1.42-1.2-1.42h-1.12v3.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7,192.81v1h-2.52v3.68h3.1v1H170V188.24h4.26v1h-3.1v3.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.81,190.72V191h-1.09v-.34c0-.93-.36-1.48-1.18-1.48s-1.18.55-1.18,1.46c0,2.32,3.47,2.54,3.47,5.45,0,1.57-.76,2.59-2.34,2.59s-2.32-1-2.32-2.59v-.59h1.08v.65c0,.93.39,1.48,1.21,1.48s1.21-.55,1.21-1.48c0-2.3-3.45-2.52-3.45-5.43,0-1.6.74-2.59,2.29-2.59S179.81,189.15,179.81,190.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3,190.72V191h-1.09v-.34c0-.93-.35-1.48-1.18-1.48s-1.18.55-1.18,1.46c0,2.32,3.47,2.54,3.47,5.45,0,1.57-.76,2.59-2.34,2.59s-2.31-1-2.31-2.59v-.59h1.07v.65c0,.93.39,1.48,1.21,1.48s1.22-.55,1.22-1.48c0-2.3-3.46-2.52-3.46-5.43,0-1.6.74-2.59,2.29-2.59S185.3,189.15,185.3,190.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.69,239.9c1.62,0,2.32,1,2.32,2.52v1.25a2.16,2.16,0,0,1-2.41,2.49h-1v4.08h-1.15V239.9Zm-.09,5.23c.86,0,1.27-.4,1.27-1.39v-1.37c0-1-.34-1.42-1.18-1.42h-1.11v4.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88,248.15l-.4,2.09h-1.06l2-10.34h1.67l2,10.34H126.9l-.4-2.09Zm.15-1h2.3l-1.16-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.42,242.38v.28h-1.09v-.34c0-.93-.36-1.48-1.18-1.48s-1.19.55-1.19,1.47c0,2.32,3.47,2.54,3.47,5.45,0,1.56-.75,2.58-2.33,2.58s-2.32-1-2.32-2.58v-.59h1.08v.65c0,.93.38,1.47,1.21,1.47s1.21-.54,1.21-1.47c0-2.31-3.45-2.53-3.45-5.44,0-1.59.73-2.58,2.29-2.58S133.42,240.81,133.42,242.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.91,242.38v.28h-1.09v-.34c0-.93-.36-1.48-1.18-1.48s-1.19.55-1.19,1.47c0,2.32,3.47,2.54,3.47,5.45,0,1.56-.75,2.58-2.33,2.58s-2.32-1-2.32-2.58v-.59h1.08v.65c0,.93.39,1.47,1.21,1.47s1.21-.54,1.21-1.47c0-2.31-3.45-2.53-3.45-5.44,0-1.59.74-2.58,2.29-2.58S138.91,240.81,138.91,242.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67,250.24h-1.58l-1.41-10.34h1.12l1.21,8.8,1.15-8.79h1.14l1.14,8.81,1.16-8.82h1l-1.41,10.34h-1.52l-1-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44,242.4c0-1.59.79-2.6,2.37-2.6s2.37,1,2.37,2.6v5.34c0,1.57-.78,2.6-2.37,2.6s-2.37-1-2.37-2.6Zm1.14,5.4c0,.95.4,1.49,1.23,1.49s1.22-.54,1.22-1.49v-5.46c0-.93-.38-1.5-1.22-1.5s-1.23.57-1.23,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58,239.9c1.62,0,2.3.83,2.3,2.36v.84c0,1.14-.4,1.85-1.28,2.13.94.28,1.3,1.05,1.3,2.16V249a2.64,2.64,0,0,0,.2,1.24h-1.16a2.61,2.61,0,0,1-.2-1.26v-1.62c0-1.17-.54-1.54-1.5-1.54h-.81v4.42h-1.16V239.9Zm-.3,4.87c.92,0,1.46-.29,1.46-1.41v-1c0-.93-.34-1.42-1.19-1.42h-1.12v3.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,239.9c1.61,0,2.35,1,2.35,2.57v5.21c0,1.58-.74,2.56-2.35,2.56h-2.42V239.9Zm0,9.29c.82,0,1.22-.52,1.22-1.46v-5.32c0-.95-.4-1.46-1.24-1.46h-1.24v8.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,290.16c1.62,0,2.3.82,2.3,2.36v.84c0,1.14-.4,1.85-1.28,2.13.94.28,1.3,1.05,1.3,2.15v1.61a2.66,2.66,0,0,0,.2,1.25h-1.16a2.64,2.64,0,0,1-.2-1.26v-1.62c0-1.17-.54-1.54-1.5-1.54h-.81v4.42H135V290.16ZM137,295c.92,0,1.46-.29,1.46-1.42v-1c0-.93-.34-1.41-1.19-1.41h-1.12V295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5,294.74v1H142v3.68h3.1v1.05h-4.25V290.16h4.25v1H142v3.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.94,300.48h-1.1l-1.72-8.23v8.25h-1V290.16h1.61l1.7,8.25,1.64-8.25h1.61V300.5h-1.1v-8.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.53,294.74v1H155v3.68h3.11v1.05h-4.26V290.16h4.26v1H155v3.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,300.48h-1.11l-1.71-8.23v8.25h-1V290.16h1.61l1.7,8.25,1.64-8.25h1.61V300.5h-1.09v-8.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.2,290.16c1.61,0,2.25.76,2.25,2.29v.48c0,1.1-.31,1.78-1.21,2.06,1,.28,1.39,1.07,1.39,2.21v.87a2.14,2.14,0,0,1-2.37,2.43h-2.37V290.16Zm-.28,4.38c.92,0,1.39-.29,1.39-1.37v-.61c0-.91-.31-1.35-1.13-1.35H168v3.33Zm.34,4.91c.85,0,1.23-.45,1.23-1.41v-.91c0-1.15-.46-1.54-1.45-1.54h-1v3.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,294.74v1h-2.53v3.68h3.11v1.05h-4.26V290.16h4.26v1h-3.11v3.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.29,290.16c1.62,0,2.3.82,2.3,2.36v.84c0,1.14-.4,1.85-1.28,2.13.94.28,1.3,1.05,1.3,2.15v1.61a2.54,2.54,0,0,0,.21,1.25h-1.17a2.8,2.8,0,0,1-.19-1.26v-1.62c0-1.17-.55-1.54-1.51-1.54h-.81v4.42H178V290.16ZM180,295c.92,0,1.47-.29,1.47-1.42v-1c0-.93-.34-1.41-1.2-1.41h-1.12V295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,300.48H186.5l-1.71-8.23v8.25h-1V290.16h1.61l1.7,8.25,1.63-8.25h1.61V300.5h-1.09v-8.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,294.74v1h-2.53v3.68h3.1v1.05h-4.25V290.16h4.25v1h-3.1v3.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.06,
    y: 325.51,
    width: 108.25,
    height: 22.49,
    rx: 3.33,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(157.6 341.97)",
    style: {
      fontSize: "14.760869979858398px",
      fill: "#fff",
      fontFamily: "BebasNeueRegular, Bebas Neue"
    }
  }, "submit"), /*#__PURE__*/React.createElement("rect", {
    x: 117.54,
    y: 203.91,
    width: 111.06,
    height: 16.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.54,
    y: 256.28,
    width: 111.06,
    height: 16.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.95,
    y: 289.67,
    width: 9.84,
    height: 9.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.2,427.92a42.14,42.14,0,0,1-13.89-.23c-7.88-1.39-16.21-8.1-16.21-8.1l-6.71.46V390.89S308,388.8,311.67,389s21.53,17.83,21.53,17.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.96 431.01 281.48 431.01 277.87 388.42 306.57 388.42 302.96 431.01",
    style: {
      fill: "#444444",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.19,
    y: 381.26,
    width: 26.73,
    height: 2.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.94,
    y: 383.17,
    width: 30.56,
    height: 8.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.69,421.21c-10.64-1.16-11.8-12.73-11.8-12.73s-8.1,5.56-11.58,5.56-4.4-2.55-5.09-4.33,15.51-12.34,15.51-12.34,3-3,5.56-3,13.42,14.81,15.51,17.36",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.87 452.01 454.03 356.87 449.79 381.48 451.46 452.01 454.87 452.01",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.17,452l.55-51.74s8.08-16.48,8.7-24.2,4.94-26.55.93-35.19-.49-37.9-.49-37.9l-3.75-13.34c-2.47-6.48-26.23-21.6-35.18-24.69a65.87,65.87,0,0,0-27.47-2.78c-8,.93-12.35,5.56-13.28,7.1s-5.86,16.36-11.73,24.39-10.8,13.89-15.12,20.06-7.1,18.83-9.88,26.24-7.41,40.43-9.57,58c-1.9,15.5-.69,46.79-.37,54Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.44,319.92a53.48,53.48,0,0,1,10.42-8.36c9.57-5.56,16.36-10.5,16.36-10.5l-1.85-10.8,9.88,4.63s2.16-6.79,8.33-18.52,6.48-14.2,6.48-14.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.42,329.07a90.37,90.37,0,0,1,6.35-7.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.45 316.15 384.03 451.9 389.12 451.9 401.85 320.39 398.45 316.15",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.69,452c-.28-12.6-1.17-64.8,3.16-84.27,4.94-22.23,9.26-47.23,16.66-57.72s22.54-23.77,30.56-31.49a56.92,56.92,0,0,0,12-17.9L393,230.69s-9.88,16.67-13,17.9c0,0,3.09,13.89.93,21.92s-16.36,30.86-20.68,36.42S342.69,343,339.91,363.41c-2.45,18-2.74,75.32-2.77,88.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.95 253.64 396.54 253.31 391.23 241.7 380.95 253.64",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.69,452c-.28-12.6-1.17-64.8,3.16-84.27,4.94-22.23,9.26-47.23,16.66-57.72s22.54-23.77,30.56-31.49a49.58,49.58,0,0,0,6.86-8.33c-8.81,6-15.81,6.2-20,5.42-4.64,10.06-15.09,26.68-18.69,31.31-4.32,5.56-17.59,36.11-20.37,56.48-2.45,18-2.74,75.32-2.77,88.6Z",
    style: {
      fill: "#444444",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.23,251.42s3,11.47,2.7,16.52-4.72,19.56-10.12,27.32-14.16,19.56-21.24,22.6-9.78,3-9.78,3a30,30,0,0,0,16.52-22.59c2.7-16.87-6.07-57.67-6.41-60.37S380.23,251.42,380.23,251.42Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,204.71s-.67,13.35.67,15.68,5,4,5,8-3.34,11.35-1.67,13.68,7.67,2.34,7.67,2.34,9,10.34,11.35,12.68,5.67,6,7.34,5.34,14.35-13.68,17.35-18.69,4.67-22.69,3.34-30.36-20-20.36-30.37-21a65.47,65.47,0,0,0-19.69,2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "353.12 219.73 355.24 225.33 363.04 220.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.35,217.53s-2.12-7.94,9.54-5.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.46,245.76s5.67-1.67,10-8.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.06,224c.32.61-.13,1.48-1,2s-1.86.36-2.18-.24.13-1.48,1-2S358.73,223.43,359.06,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.78,174.34s-21.69,14-20,18.69,12.68,11.68,12.68,11.68l1-7.34s11.35,5.67,22,9.68l10.68,4a69,69,0,0,0,5,5c1.34,1,6,1,6,1s1.67,35.7,8,44.05,24.69,16,37,21.35,17.78,5.76,21.12,10.43S457,312.41,457,312.41s20.18-20.84-8.4-70.33c-20.73-35.9-18.35-40-25.36-52.05s-24-29.7-40.71-31S348.78,174.34,348.78,174.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.42,259.16a65.57,65.57,0,0,0,7.12,3.29",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.33,172.22a55.45,55.45,0,0,1,19.17,35c2.23,17.83,9.74,35.66,25.6,47.36",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.91,189.75a70.86,70.86,0,0,1,12.24,5",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.42,194.21s-5.64-2.25.57-6.76c3.67-2.68,13.49-1.78,23.23.68",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.16,214.05s-2.67-22.35-9-31",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39,362.8l-23.91-18.28a1.22,1.22,0,0,1,.58-2.18l12.56-1.7a6.48,6.48,0,0,1,4.91,1.34l24.38,19.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.85,364s-5.56-4.94-7.41-7.71a9.59,9.59,0,0,0-9.26-3.71c-3.4.62-11.11-1.23-12.35.31s-1.23,5.56-1.23,5.56-19.14,1.23-20.68.92-2.78,2.16-1.55,4.32,10.2,4.56,10.2,4.56h0a11.29,11.29,0,0,0,1.15,5c1.32,2.68,3.51,6.84,5.32,8.64,2.78,2.78,8.64,4,14.82,5.25s16.05-.31,16.05-.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.6,
    y1: 358.48,
    x2: 304.1,
    y2: 357.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.57,368.28a57.84,57.84,0,0,1,10.17.34c4.07.67,7.46,1.35,9.83.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.72,373.29a71.44,71.44,0,0,1,8.68,2.11c2.71,1,7.12,3.72,11.52,2.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,380.14s7.46,3.39,13.22,3.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.72,303.53S452,318,452,328.54s-1.23,31.79-8.33,46.29-5.25,24.7-12.35,39.21-12,14.81-32.41,13-43.52-9.57-44.75-9.57S334.66,414,326,409.71a153.74,153.74,0,0,1-17-10.18,27.75,27.75,0,0,1,1.85-7.41c1.55-3.7,6.49-30.56,6.49-30.56a101.93,101.93,0,0,0,17.9,8.34,123.07,123.07,0,0,0,16.67,4s5.86-3.7,7.71-4.32,5.56,3.7,10.81,4.94A127.85,127.85,0,0,0,385,377c1.24,0,13.85-1.5,13-1.24-1.13.34-2.18-2-1.85-4a52.63,52.63,0,0,1,4-9.26c.92-1.24.92-5.87.92-8.95s-4.32-35.5-2.16-44.45S414,281.62,414,281.62s.57-2.79,7.41-2.78,17.9,7.41,22.53,11.42",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.23,321.07A27.86,27.86,0,0,0,434.7,315a17.78,17.78,0,0,0-11.95-.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.3,325.64s-.92-1.23-2.44-2.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.89,396.16a1.8,1.8,0,1,1-1.8-1.8A1.81,1.81,0,0,1,316.89,396.16Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.79,387.76a26.35,26.35,0,0,0,3.81,3.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.55,374.22s5.49,6.4,10.18,11.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,391.23a48,48,0,0,0,3.23,4.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,375.14s3.95,7.18,7.92,13.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.58,393.06c-1.27,6-2.69,11.34-4,13.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.57,370.21s-1.24,8.72-3,17.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-62"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 452.01,
    x2: 22,
    y2: 452.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.39,
    y1: 452.01,
    x2: 102,
    y2: 452.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLogo);
export default __webpack_public_path__ + "static/media/Account_logo.f5b71f9d5ea74c8f38e6ec229b855d35.svg";
export { ForwardRef as ReactComponent };